import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpParams } from '@capacitor/core';
import { ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

export interface IArquivoLeitura {
  guid?: string;
  empresas?: string;
  nomeArquivo?: string;
  tipo?: number;
  idgestor?: string | null;
  texto?: string;
  usuarioCriacao?: string;
  dataInclusao?: string;
  dataInicioVigencia?: string;
  dataFimVigencia?: string;
  urlTarget?: string;
  rotaAplicacao?: string | null;
  isExterno?: boolean;
  disparo?: number;
  frequencia?: number;
  repetir?: number;
  isAtivo?: boolean | null;
  base64?: string | null;
}

@Injectable()

export class BannersProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  

  get(tipo, periodoDe, periodoAte,ativo) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      
      let url = `${APIService.API_URL}banner?tipo=${tipo?tipo:''}&periodoDe=${periodoDe?periodoDe:''}&periodoAte=${periodoAte?periodoAte:''}&isAtivo=${ativo?ativo:''}`;

      me.http.get(url, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  
  post(dto: any): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'banner';
      me.http.post(url, dto, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  postAjustarPosicao(lista: any): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'banner?operacao=ajustarposicao';
      me.http.post(url, lista, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  

  delete(id: string): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();
    

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'banner';

      me.http.delete(url, {headers: this.header, params: {
        id: id
      }}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });

    });
  }

   /** ACESSSOS AS ROTAS */

  getAcesso(guidBanner) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      
      let url = `${APIService.API_URL}banneracesso?guidBanner=${guidBanner}`;

      me.http.get(url, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  
  postAcesso(guidBanner, guid, clicouNoLink): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data ={
        guidBanner: guidBanner,
        clicouNoLink:clicouNoLink,
        guid:guid
      }
      
      let url = APIService.API_URL + 'banneracesso';
      me.http.post(url, JSON.stringify(data), {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  

}
